export enum Role {
  SuperAdmin = 'SuperAdmin',
  Admin = 'Admin',

  Inactive = 'Inactive',

  Examined = 'Examined',
  Public = 'Public',
  Interpreter = 'Interpreter',

  Office = 'Office',
  ExtendedRegistration = 'ExtendedRegistration',
  MedicalRegistration = 'MedicalRegistration',

  ExternalRegistration = 'ExternalRegistration',
  ExternalVisitBooking = 'ExternalVisitBooking',

  PsychologistAssessor = 'PsychologistAssessor',
  PsychologistSpecialist = 'PsychologistSpecialist',
  MedicalAssessor = 'MedicalAssessor',
  MedicalSpecialist = 'MedicalSpecialist',

  Neurologist = 'Neurologist',
  Ophthalmologist = 'Ophthalmologist',
  Psychiatrist = 'Psychiatrist',
  Laryngologist = 'Laryngologist',

  Finance = 'Finance',
  BasicFinance = 'BasicFinance',
}

export enum RoleText {
  Examined = 'Badany',
  Public = 'Użytkownik publiczny',
  Interpreter = 'Interpretator',

  Office = 'Biuro',
  ExtendedRegistration = 'Rejestracja rozszerzona',
  MedicalRegistration = 'Rejestracja medyczna',

  ExternalRegistration = 'Rejestracja zewnętrzna',
  ExternalVisitBooking = 'Wizyty - partnerzy',

  PsychologistAssessor = 'Psycholog orzecznik',
  PsychologistSpecialist = 'Psycholog specjalista',
  MedicalAssessor = 'Lekarz orzecznik',
  MedicalSpecialist = 'Lekarz specjalista',

  Neurologist = 'Neurolog',
  Ophthalmologist = 'Okulista',
  Psychiatrist = 'Psychiatra',
  Laryngologist = 'Laryngolog',

  Finance = 'Finanse',
  BasicFinance = 'Finanse podstawowe',
}

export const ROLES_EXEMPT_FROM_2FA: Role[] = [
  Role.Examined,
  Role.Public,
  Role.Interpreter,
];

//12
export const ALL_WORKERS_ROLES = Object.values(Role).filter(
  role =>
    role !== Role.Public &&
    role !== Role.Examined &&
    role !== Role.Inactive &&
    role !== Role.ExternalRegistration &&
    role !== Role.ExternalVisitBooking &&
    role !== Role.Interpreter,
);

//8
export const ALL_WORKERS_WITHOUT_CONSULTATION = Object.values(Role).filter(
  role =>
    role !== Role.Public &&
    role !== Role.Examined &&
    role !== Role.Inactive &&
    role !== Role.ExternalRegistration &&
    role !== Role.ExternalVisitBooking &&
    role !== Role.Interpreter &&
    role !== Role.Neurologist &&
    role !== Role.Ophthalmologist &&
    role !== Role.Psychiatrist &&
    role !== Role.Laryngologist,
);

//4
export const ALL_WORKERS_REGISTRATION = Object.values(Role).filter(
  role =>
    role === Role.Admin ||
    role === Role.MedicalRegistration ||
    role === Role.Office ||
    role === Role.ExtendedRegistration,
);

export const MEDICAL_ROLES = [
  Role.PsychologistAssessor,
  Role.PsychologistSpecialist,
  Role.MedicalAssessor,
  Role.MedicalSpecialist,
  Role.Neurologist,
  Role.Ophthalmologist,
  Role.Psychiatrist,
  Role.Laryngologist,
];

export const REGISTRATION_WITH_CONSULTATION = Object.values(Role).filter(
  role =>
    role === Role.Admin ||
    role === Role.MedicalRegistration ||
    role === Role.Office ||
    role === Role.ExtendedRegistration ||
    role === Role.Neurologist ||
    role === Role.Ophthalmologist ||
    role === Role.Psychiatrist ||
    role === Role.Laryngologist,
);
